const baseUrl = '/';

const fetchPersonal = (endpoint, data, method = 'GET') => {
  const url = `${baseUrl}${endpoint}`

  if (method === 'GET') {
    return fetch(url)
  }
  return fetch(url, {
    method,
    headers: {
      accept: 'application/json',
    },
    body: JSON.stringify(data),
  })
}



export { fetchPersonal }
